"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityList = void 0;
const hooks_1 = require("../../../../../../ui/hooks");
const mapEntityListRequest_1 = require("../utils/mapEntityListRequest");
function useEntityList(props, request) {
    const response = (0, hooks_1.useStorageList)(props.entity, (0, mapEntityListRequest_1.mapEntityListRequest)(props, request));
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
exports.useEntityList = useEntityList;
